import React from 'react';
import { motion } from 'framer-motion';
import { PlaySquare, CalendarCheck, Infinity as InfinityIcon, MessageCircle, ShieldCheck } from 'lucide-react';

export default function SolutionSection({ course }) {
  const exerciseCount = course?.exercise_ids?.length || 10;
  const weeks = course?.duration_weeks || 6;
  const title = course?.title || 'HIP & BACK Pain Fundamentals';

  const items = [
    { icon: PlaySquare, text: `${exerciseCount} step-by-step exercise videos` },
    { icon: CalendarCheck, text: `${weeks}-week structured rebuild plan` },
    { icon: InfinityIcon, text: 'Lifetime access — learn at your own pace' },
    { icon: MessageCircle, text: 'Direct 1:1 messaging support with me' },
    { icon: ShieldCheck, text: '30-day money-back guarantee' },
  ];

  return (
    <section className="py-20 sm:py-24 px-6 bg-[#0B0B0B] text-white" data-testid="solution-section">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-xs uppercase tracking-widest text-[#C6A97C] mb-4 font-semibold">The Solution</div>
            <h2 className="text-4xl sm:text-5xl font-bold leading-tight mb-6" style={{ fontFamily: 'Clash Display' }}>
              A Proven {weeks}-Week System To Fix The <span className="text-[#C6A97C]">Root Cause</span> And Build A Stronger, More Resilient You.
            </h2>
            <p className="text-gray-400 leading-relaxed max-w-lg">
              This isn't another band-aid program. My {weeks}-week {title} program rebuilds your body from the ground up so you can move pain-free and stay that way.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-5"
          >
            {items.map((item, i) => (
              <div key={i} className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl px-5 py-4" data-testid={`solution-item-${i}`}>
                <item.icon className="w-6 h-6 text-[#C6A97C] shrink-0" />
                <span className="text-base sm:text-lg">{item.text}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
